import { render, staticRenderFns } from "./RevenueScheduleSave.vue?vue&type=template&id=5b120621&"
import script from "./RevenueScheduleSave.vue?vue&type=script&lang=js&"
export * from "./RevenueScheduleSave.vue?vue&type=script&lang=js&"
import style0 from "./RevenueScheduleSave.vue?vue&type=style&index=0&id=5b120621&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports